import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RatingModal } from './rating.modal';
import { QRCodeModule, RatingModule } from 'ionic4-kits';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    QRCodeModule,
    RatingModule
  ],
  declarations: [RatingModal],
  entryComponents: [
    RatingModal
  ],
  exports: [
    RatingModal
  ]
})
export class RatingModalModule {}
